import accessToRGSServicesDictionary from '@widgets/access-to-rgs-services/i18n/ru/access-to-rgs-services.dic.json';

export const accessToRGSServices = {
  ACCESS_TO_RGS_SERVICES: accessToRGSServicesDictionary,
};

export const accessToRGSServicesNamespaces = Object.keys(accessToRGSServices);
